import React from 'react';

function ExpenseFeature({ isMobile, t }) {
  return (
    <section
      style={{
        marginTop: 200,
        marginBottom: 40,
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
      }}
    >
      <div
        style={{
          maxWidth: '1200px',
          width: '100%',
          padding: isMobile ? '0 20px' : '0 40px',
          color: '#f9fafb'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 16,
            justifyContent: 'center'
          }}
        >
          <div
            style={{
              justifyContent: 'center',
              borderRadius: 18,
              padding: 18,
              backdropFilter: 'blur(10px)',
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              gap: isMobile ? 24 : 30,
              alignItems: isMobile ? 'stretch' : 'center'
            }}
          >
            
            <div style={{ flex: 1, alignItems: 'flex-center', justifyContent: 'flex-center', maxWidth: 400 }}>
              <h3
                style={{
                  margin: '0 0 8px 0',
                  fontSize: '2rem',
                  fontFamily: 'Poppins-Medium'
                }}
              >
                {t.ExpenseFeatureTitle}
              </h3>
              <p
                style={{
                  margin: 0,
                  fontSize: '1.1rem',
                  opacity: 0.9,
                  lineHeight: 1.6
                }}
              >
                {t.ExpenseFeatureText}
              </p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {/* Carte dépense 1 */}
              <div style={{
                backgroundColor: 'rgba(30, 41, 59, 0.8)',
                borderRadius: 15,
                padding: '16px',
                border: '1px solid rgba(148, 163, 184, 0.2)',
                display: 'flex',
                justifyContent: 'flex-center',
                alignItems: 'center'
              }}>
                <div style={{ flex: 1, textAlign: 'start' }}>
                  <h4 style={{ margin: '0 0 4px 0', fontSize: '0.8rem', fontWeight: 'bold', color: '#ffffff', fontFamily: 'Poppins-Medium' }}>
                    {t.planetickets}
                  </h4>
                  <p style={{ margin: 0, fontSize: '0.65rem', color: '#cbd5e1', fontFamily: 'Poppins-Medium' }}>
                    {t.paidBy} <span style={{ color: '#a5b4fc' }}>Emily</span>
                  </p>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '0 46px' }}>
                  <span style={{ fontSize: '1rem' }}>✈️</span>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <p style={{ margin: '0 0 4px 0', fontSize: '0.8rem', fontWeight: 'bold', color: '#ffffff', fontFamily: 'Poppins-Medium' }}>
                    558.00 {t.devise}
                  </p>
                  <p style={{ margin: 0, fontSize: '0.65rem', color: '#94a3b8', fontFamily: 'Poppins-Medium' }}>
                    22 {t.september} 2025
                  </p>
                </div>
              </div>
              
              {/* Carte dépense 2 */}
              <div style={{
                backgroundColor: 'rgba(30, 41, 59, 0.8)',
                borderRadius: 15,
                padding: '16px',
                border: '1px solid rgba(148, 163, 184, 0.2)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}>
                <div style={{ flex: 1, textAlign: 'start' }}>
                  <h4 style={{ margin: '0 0 4px 0', fontSize: '0.8rem', fontWeight: 'bold', color: '#ffffff', fontFamily: 'Poppins-Medium' }}>
                    {t.karting}
                  </h4>
                  <p style={{ margin: 0, fontSize: '0.65rem', color: '#cbd5e1', fontFamily: 'Poppins-Medium' }}>
                    {t.paidBy} <span style={{ color: '#a5b4fc' }}>Sophia</span>
                  </p>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '0 40px' }}>
                  <span style={{ fontSize: '1rem' }}>🏎️</span>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <p style={{ margin: '0 0 4px 0', fontSize: '0.8rem', fontWeight: 'bold', color: '#ffffff', fontFamily: 'Poppins-Medium' }}>
                    128.00 {t.devise}
                  </p>
                  <p style={{ margin: 0, fontSize: '0.65rem', color: '#94a3b8', fontFamily: 'Poppins-Medium' }}>
                    18 {t.september} 2025
                  </p>
                </div>
              </div>
              
              {/* Carte dépense 3 */}
              <div style={{
                backgroundColor: 'rgba(30, 41, 59, 0.8)',
                borderRadius: 15,
                padding: '16px',
                border: '1px solid rgba(148, 163, 184, 0.2)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}>
                <div style={{ flex: 1, textAlign: 'start' }}>
                  <h4 style={{ margin: '0 0 4px 0', fontSize: '0.8rem', fontWeight: 'bold', color: '#ffffff', fontFamily: 'Poppins-Medium' }}>
                    {t.boat}
                  </h4>
                  <p style={{ margin: 0, fontSize: '0.65rem', color: '#cbd5e1', fontFamily: 'Poppins-Medium' }}>
                    {t.paidBy} <span style={{ color: '#a5b4fc' }}>{t.me}</span>
                  </p>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '0 40px' }}>
                  <span style={{ fontSize: '1rem' }}>🚢</span>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <p style={{ margin: '0 0 4px 0', fontSize: '0.8rem', fontWeight: 'bold', color: '#ffffff', fontFamily: 'Poppins-Medium' }}>
                    66.00 {t.devise}
                  </p>
                  <p style={{ margin: 0, fontSize: '0.65rem', color: '#94a3b8', fontFamily: 'Poppins-Medium' }}>
                    17 {t.september} 2025
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ExpenseFeature;

